import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { flooringUseMutation } from "../hooks";
import FlooringConst from "../flooring-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import { TFlooring } from "../helpers/flooring-types-helper";
import Icons from "components/icons";
import { usePermissionByObject, useModelFormValidation } from "components/permissions";
import Flooring from "components/flooring";


interface IFlooringActionFieldProps
{
  flooring: TFlooring | undefined;
}

const FlooringActionField: React.FC<IFlooringActionFieldProps> = ({ flooring }) =>
{
  const navigate = useNavigate();

  const { _setMutationFlooringDelete, loadingMutationFlooringDelete } =
    flooringUseMutation.delete(flooring?.id);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Flooring.Const.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(Flooring.Const.permissions.DELETE);
  const { validateDeletePermission } = useModelFormValidation(Flooring.Const);

  const items = [
    {
      label: (
        <Tooltip
          title={!hasUpdatePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Flooring.Const.permissions.UPDATE.slug)}` : undefined}
        >
          <span style={{ display: "flex", alignItems: "center", width: 100 }}>
            <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      onClick: () => {
        if (!hasUpdatePermission) return;
        navigate(`${FlooringConst.basePath}/${flooring?.id}`);
      },
      disabled: !hasUpdatePermission,
    },
    {
      key: "2",
      label: (
        <Tooltip
          title={!hasDeletePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Flooring.Const.permissions.DELETE.slug)}` : undefined}
        >
          <EntityRemoveButton
            modalButton={
              <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={
              localizeByKey("ENTITY.Modal_Title_Flooring")
            }
            dataNameEntity={flooring?.title}
            loading={loadingMutationFlooringDelete}
            deleteMutation={(options) =>
            {
              if (!validateDeletePermission()) {
                return Promise.reject(new Error('Access denied'));
              }
              return _setMutationFlooringDelete(options);
            }}
            variables={{
              id: flooring?.id,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default FlooringActionField;
